import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue' 
// import Table from './views/nav1/Table.vue'
// import Form from './views/nav1/Form.vue'
// import user from './views/nav1/user.vue'
// import Page4 from './views/nav2/Page4.vue'
// import Page5 from './views/nav2/Page5.vue'
// import Failure from './views/nav2/failure.vue'
// import Success from './views/nav2/success.vue'
// import Page6 from './views/nav3/Userdata.vue'
// import echarts from './views/charts/echarts.vue'
import personalData from './views/personalData/index.vue'
// import Management from './views/Management/Management'
// import Identity from './views/Management/identity.vue'
// import PermisSions from './views/Management/permissions.vue'
// import Role from './views/Management/role.vue'
// import allRechargeRecords from './views/nav2/allRechargeRecords.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    //{ path: '/main', component: Main },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '数据展示',
    //     iconCls: 'fa fa-bar-chart',
    //     leaf: true,
    //     children: [
    //         { path: '/echarts', component: echarts, name: '数据展示' }
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '小程序管理',
    //     iconCls: 'fa fa-bar-chart',//图标样式class
    //     children: [
    //         // { path: '/main', component: Main, name: '主页', hidden: true },
    //         { path: '/table', component: Table, name: '设备管理' },
    //         { path: '/form', component: Form, name: 'banner管理' },
    //         { path: '/user', component: user, name: '商品列表' },
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '记录管理',
    //     iconCls: 'fa fa-id-card-o',
    //     children: [
    //         { path: '/recharge', component: allRechargeRecords, name: '全部记录' },
    //         { path: '/page4', component: Page4, name: '充值成功' },
    //         { path: '/page5', component: Page5, name: '支付失败' },
    //         { path: '/success', component: Success, name: '充值失败' },
    //         { path: '/failure', component: Failure, name: '退款记录' }
    //     ]
    // },
    {
        path: '/',
        component: Home,
        name: '个人资料',
        iconCls: 'fa fa-id-card-o',
        leaf: true,
        hidden: true,
        children: [
            { path: '/personalData', component: personalData, name: '资料编辑' },
        ]
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '用户管理',
    //     iconCls: 'fa fa-address-card',
    //     leaf: true,//只有一个节点 
    //     children: [
    //         { path: '/userData', component: Page6, name: '用户管理' },
    //         // { path: '/checkDetails', component: checkDetails, name: '查看详情' }
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '权限管理',
    //     iconCls: 'fa fa-bar-chart',
    //     children: [ 
    //         { path: '/permissions', component: PermisSions, name: '权限规则'},
    //         { path: '/identity', component: Identity, name: '角色管理'}, 
    //         { path: '/role', component: Role, name: '权限分配'},
    //         { path: '/Management', component: Management, name: '管理员列表'}
    //     ]
    // },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js